// extracted by mini-css-extract-plugin
export default {"loader":"Spinner_loader__2Dv46","load8":"Spinner_load8__4H8B4"};